import { TYPES } from '../actions/types';

const initialState = {
  flows: [],
  currentFlow: null,
  loading: true,
  error: null
};

export const k3flowReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case TYPES.ACTION_GET_K3FLOWS_SUCCESS:
      return {
        ...state,
        flows: payload,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_K3FLOWS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };
    case TYPES.ACTION_GET_K3FLOW_SUCCESS:
      return {
        ...state,
        currentFlow: payload,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_K3FLOW_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };
    case TYPES.ACTION_SET_K3FLOWS_SUCCESS:
      var updatedIds = payload.map(ws => ws._id);
      return {
        ...state,
        flows: [
          ...state.flows.filter(ws => !updatedIds.includes(ws._id)),
          ...payload
        ].sort((a, b) => {
          const dateA = new Date(a.updatedAt).getTime();
          const dateB = new Date(b.updatedAt).getTime();
          return dateB - dateA;
        }),
        loading: false,
        error: null
      };
    case TYPES.ACTION_SET_K3FLOWS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };
    default:
      return state;
  }
}; 